<template>
    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-4 mb-4">
        <div class="card h-100">
            <div class="card-header ">
                <h5 class="card-title">Collaborations</h5>
            </div>
            <div class="card-body">
                <b class="mr-2">Access To My Account</b>
                <small class="text-primary"><b>({{collaborators.length}})</b></small>
                <ul class="list-unstyled mt-2">
                   <li class="d-flex justify-content-between align-items-center mb-2" v-for="(collaboration, index) in collaborators" :key="'collaborator_'+index">
                       <div class="collaboration_container">
                           <div>
                               <img :src="`https://www.gravatar.com/avatar/${emailToHash(collaboration.email)}?s=40`" />
                           </div>
                           <div style="flex-grow: 2; padding-left: 10px">
                               <div v-if="collaboration.name">
                                   <strong :class="(collaboration.status === 'pending') ? 'text-danger' : 'text-primary'">{{ collaboration.name }}</strong><br/>
                               </div>
                               <span :class="(collaboration.status === 'pending') ? 'text-danger' : 'text-primary'" v-if="collaboration.name">
                                            {{ collaboration.email }}
                                            <i data-toggle="tooltip" data-placement="top" title="Access will be granted to your collaborator as soon as they accept your collaboration request" class="fa fa-clock-o m_tip" v-if="collaboration.status === 'pending'"></i>
                                        </span>
                               <strong :class="(collaboration.status === 'pending') ? 'text-danger' : 'text-primary'" v-else>
                                   {{ collaboration.email }}
                                   <i data-toggle="tooltip" data-placement="top" title="Access will be granted to your collaborator as soon as they accept your collaboration request" class="fa fa-clock-o m_tip" v-if="collaboration.status === 'pending'"></i>
                               </strong>
                           </div>
                           <div>
                               <ul class="list-inline" style="display: inline-flex;">
                                   <li><button class="btn btn-outline-primary btn-sm mr-2 collab_btns" style="margin: 0" @click="viewDetail(collaboration)"><i class="fa fa-pencil"></i></button></li>
                                   <li><button class="btn btn-outline-danger btn-sm collab_btns" style="margin: 0" @click="removeCollaboration(collaboration)"><i class="fa fa-trash"></i></button></li>
                               </ul>
                           </div>
                       </div>
                   </li>
                   <p class="text-center text-secondary mt-3" v-if="collaborators.length === 0">No collaborations are active.</p>
               </ul>
                <b class="mr-2">My Access</b>
                <small class="text-primary"><b>({{supervisors.length}})</b></small>
                <small v-if="isPendingRequest" class="text-danger"> - New Request</small>
                <ul class="list-unstyled mt-2">
                    <li class="d-flex justify-content-between align-items-center mb-2" v-for="(collaboration, index) in supervisors" :key="'collab_dash_'+index">
                        <div class="collaboration_container">
                            <div>
                                <img :src="`https://www.gravatar.com/avatar/${emailToHash(collaboration.supervisorEmail)}?s=45`" />
                            </div>
                            <div class="big_item" v-if="collaboration.status !== 'pending'">
                                <router-link tag="a"  :to="{ name: 'CollaboratorSites', params: { userId: collaboration.supervisorId } }" >
                                    <strong class="text-primary">{{ collaboration.supervisorName }}</strong><br/>
                                    <span>{{ collaboration.supervisorEmail }}</span>
                                </router-link>
                            </div>
                            <div class="big_item" v-else>
                                <strong class="text-secondary">{{ collaboration.supervisorName }}</strong> <br/>
                                <span style="color: black">{{ collaboration.supervisorEmail }}</span>
                            </div>
                            <div v-if="collaboration.status !== 'pending'">
                                <router-link tag="a"  :to="{ name: 'CollaboratorSites', params: { userId: collaboration.supervisorId } }" class="btn btn-outline-primary btn-sm collab_btns mr-2"><i class="fa fa-eye"></i></router-link>
                                <button @click="deactivateCollaboration(collaboration, $event)" class="btn btn-outline-danger btn-sm collab_btns" title="Click to De-Activate"><i class="fa fa-trash"></i></button>
                            </div>
                            <div v-else>
                                <button @click="acceptCollaboration(collaboration)" class="btn btn-outline-danger btn-sm collab_btns" title="Waiting for approval"><i class="fa fa-clock-o"></i> Click To Accept</button>
                            </div>
                        </div>
                    </li>
                    <p class="text-center text-secondary mt-3" v-if="supervisors.length === 0">You do not have access to any other account.</p>
                </ul>
            </div>
            <div class="card-footer pt-0">
                <hr class="mt-0">
                <div class="stats">
                    <router-link v-if="!isNewAccount" tag="a" to="/collaborators/" class="text-secondary nounderline">
                        <i class="fa fa-server"></i> More Details
                    </router-link>
                    <a href="javascript:void(0)" class="pull-right text-secondary nounderline" data-toggle="modal" data-target="#createCollaborator">
                        <i class="fa fa-users"></i> Add Collaborator
                    </a>
                </div>
            </div>
        </div>
        <collaborator-create-modal v-on:update-list="listData()"/>
        <div class="modal fade" id="collaboratorDetail" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="editRecord" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title d-inline">{{selectedCollaborator.email}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <h6>Assign / Remove Domains</h6>
                        <div class="form-check" style="margin-top: 20px;margin-bottom: 10px">
                            <label class="form-check-label">
                                <input class="form-check-input" type="checkbox" v-model="selectedCollaborator.allowAll" />
                                Access to all domains
                                <span class="form-check-sign"></span>
                            </label>
                        </div>
                        <div class="mb-2"><b>OR</b></div>
                        <multi-select :clear-on-select="true" :close-on-select="false" :multiple="true"
                                      :options="domains" :disabled="selectedCollaborator.allowAll" placeholder="Select Domain (s)"
                                      v-model="selectedCollaborator.domains"/>
                        <h4>Access Level: </h4>
                        <div class="form-check" style="margin-top: 20px;margin-bottom: 10px">
                            <label class="form-check-label">
                                <input class="form-check-input" type="checkbox" value="full" v-model="selectedCollaborator.accessLevels" />
                                Full Access
                                <span class="form-check-sign"></span>
                                <span data-toggle="tooltip" data-placement="top" style="cursor: pointer" title="Pushing and pulling between staging and live, as well as adjusting DNS or redirects are only available with full access." class="m_tip"><i class="fa fa-question-circle text-primary"></i></span>
                            </label>
                        </div>
                        <div :class="(selectedCollaborator.accessLevels.includes('full')) ? 'form-check disabled': 'form-check'" style="margin-top: 20px;margin-bottom: 10px">
                            <label class="form-check-label">
                                <input :disabled="selectedCollaborator.accessLevels.includes('full')" class="form-check-input" type="checkbox" value="live" v-model="selectedCollaborator.accessLevels" />
                                Live Details
                                <span class="form-check-sign"></span>
                            </label>
                        </div>
                        <div :class="(selectedCollaborator.accessLevels.includes('full')) ? 'form-check disabled': 'form-check'" style="margin-top: 20px;margin-bottom: 10px">
                            <label class="form-check-label">
                                <input :disabled="selectedCollaborator.accessLevels.includes('full')" class="form-check-input" type="checkbox" value="staging" v-model="selectedCollaborator.accessLevels" />
                                Staging Details
                                <span class="form-check-sign"></span>
                            </label>
                        </div>
                        <div :class="(selectedCollaborator.accessLevels.includes('full')) ? 'form-check disabled': 'form-check'" style="margin-top: 20px;margin-bottom: 10px">
                            <label class="form-check-label">
                                <input :disabled="selectedCollaborator.accessLevels.includes('full')" class="form-check-input" type="checkbox" value="installation" v-model="selectedCollaborator.accessLevels" />
                                New WP installation or migration requests
                                <span class="form-check-sign"></span>
                            </label>
                        </div>
                        <div :class="(selectedCollaborator.accessLevels.includes('full')) ? 'form-check disabled': 'form-check'" style="margin-top: 20px;margin-bottom: 10px">
                            <label class="form-check-label">
                                <input :disabled="selectedCollaborator.accessLevels.includes('full')" class="form-check-input" type="checkbox" value="tickets" v-model="selectedCollaborator.accessLevels" />
                                All support tickets
                                <span class="form-check-sign"></span>
                            </label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
                        <button :disabled="(!selectedCollaborator.allowAll && selectedCollaborator.domains.length === 0)" type="button" class="btn btn-outline-primary btn-sm" @click="updateDomainInCollaborator()">
                            <div class="loader mini_loader" v-if="action === 'update'"></div>
                            <span v-else>Update</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { db } from "@/firebase/init"
    import md5 from 'crypto-js/md5'
    import MultiSelect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import swal from 'sweetalert2'
    import CollaboratorCreateModal from "../Collaborator/CollaboratorCreateModal.vue";
    export default {
        name: "Collaborations",
        data () {
            return {
                supervisors: [],
                collaborators: [],
                selectedCollaborator: {
                    accessLevels: [],
                    domains: []
                },
                action: '',
                isPendingRequest: false
            }
        },
        components: {MultiSelect, CollaboratorCreateModal},
        computed: {
            domains() {
                const accounts = this.$store.getters['hosting/accounts'];
                if(accounts === undefined){
                    return [];
                }
                let domains = [];
                for(const account of accounts){
                    domains.push(account.primary.domain);
                    for(let adon of account.addon){
                        domains.push(adon.domain);
                    }
                }
                return domains;
            },
            user() {
                return this.$store.getters.user;
            },
            isNewAccount () {
                const hostingDetail = this.$store.getters["hosting/accounts"];
                return (hostingDetail && hostingDetail[0] && hostingDetail[0].primary.domain === '');
            }
        },
        created() {
            this.listData();
        },
        updated() {
            $(".m_tip").tooltip();
        },
        methods: {
            emailToHash(email){
                return md5(email.trim().toLowerCase()).toString();
            },
            listData(){
                this.isPendingRequest = false;
                db.collection("users")
                    .doc(this.user.uid)
                    .get()
                    .then(doc => {
                        const supervisors = doc.data()['supervisors'];
                        const collaborators = doc.data()['collaborators'];
                        this.supervisors = (supervisors === undefined) ? [] : supervisors;
                        this.collaborators = (collaborators === undefined) ? [] : collaborators;
                        for(const supervisor of this.supervisors){
                            if(supervisor.status === 'pending'){
                                this.isPendingRequest = true;
                                break;
                            }
                        }
                    });
            },
            viewDetail(collaborator) {
                console.log(collaborator);
                if(!collaborator.accessLevels) {
                    collaborator.accessLevels = [];
                }
                this.selectedCollaborator = collaborator;
                /* eslint-disable */
                $("#collaboratorDetail").modal('show');
                /* eslint-enable */
            },
            async updateDomainInCollaborator(){
                if(this.selectedCollaborator.accessLevels.length === 0) {
                    swal({
                        title: "Invalid Access Level!",
                        text: "Please select at least one access level.",
                        type: "error",
                        confirmButtonText: "OK!",
                        confirmButtonColor: "#EE8057"
                    });
                    return false;
                }
                if(this.selectedCollaborator.accessLevels.includes('full')) {
                    this.selectedCollaborator.accessLevels = this.selectedCollaborator.accessLevels.filter(level => level === 'full');
                    console.log(this.selectedCollaborator.accessLevels);
                }
                this.action = 'update';
                console.log(this.collaborators);
                if(this.selectedCollaborator.allowAll) {
                    this.selectedCollaborator.domains = [];
                    for(const domain of this.domains) {
                        this.selectedCollaborator.domains.push(domain);
                    }
                }
                await db.collection('users').doc(this.user.uid).update({
                    collaborators: this.collaborators
                });

                if(this.selectedCollaborator.uid !== ''){
                    const collaboratorData = await db.collection('users').doc(this.selectedCollaborator.uid).get();
                    if(collaboratorData.exists){
                        const allSupervisors = collaboratorData.data()['supervisors'];
                        for(let supervisor of allSupervisors){
                            if(supervisor.supervisorId === this.user.uid){
                                supervisor.allowedDomains = this.selectedCollaborator.domains;
                                supervisor.allowAll = this.selectedCollaborator.allowAll || false;
                                supervisor.accessLevels = this.selectedCollaborator.accessLevels;
                                break;
                            }
                        }
                        await db.collection('users').doc(this.selectedCollaborator.uid).update({
                            supervisors: allSupervisors
                        })
                    }
                }
                /* eslint-disable */
                $("#collaboratorDetail").modal('hide');
                /* eslint-enable */
                this.listData();
                swal('Success!', 'Collaborator has been updated!', 'success');
                this.action = '';
            },
            removeCollaboration(collaborator) {
                this.selectedCollaborator = collaborator;
                swal({
                    title: "Removing collaborator",
                    html: "Are you sure that you want to remove <b>" + collaborator.email + "</b> access to your" +
                        " account? You may re-add it at any time.",
                    type: "question",
                    confirmButtonText: "Yes Proceed",
                    confirmButtonColor: "#6ACF98",
                    showCancelButton: true,
                    cancelButtonText: "No Thanks",
                    cancelButtonColor: "#EE8057"
                })
                    .then(result => {
                        if (result.value) {
                            // Set asyncDone to false
                            this.action = 'remove';
                            this.collaborators = this.collaborators.filter(item => item.email !== collaborator.email);
                            db.collection('users').doc(this.user.uid).update({
                                collaborators: this.collaborators
                            }).then(async () => {
                                /* eslint-disable */
                                $("#collaboratorDetail").modal('hide');
                                if(collaborator.uid !== ''){
                                    const supervisorsRef = await db.collection('users').doc(collaborator.uid).get();
                                    let supervisors = supervisorsRef.data()['supervisors'];
                                    supervisors = supervisors.filter(item => item.supervisorEmail !== this.user.email);
                                    await db.collection('users').doc(collaborator.uid).update({
                                        supervisors: supervisors
                                    });
                                }
                                /* eslint-enable */
                                swal('Success!', 'Collaborator has been removed!', 'success');
                            }).finally(() => {
                                this.action = '';
                            });
                        }
                    })
            },
            async acceptCollaboration(selectionSupervisor) {
                try{
                    swal({
                        title: "Collaboration Request",
                        text: "Would you like to collaborate?",
                        type: "question",
                        confirmButtonText: "Yes Proceed",
                        confirmButtonColor: "#6ACF98",
                        showCancelButton: true,
                        cancelButtonText: "No Thanks",
                        cancelButtonColor: "#EE8057"
                    }).then(async result => {
                        if(result.value){
                            selectionSupervisor.status = 'accepted';
                            await db.collection('users').doc(this.user.uid).update({
                                supervisors: this.supervisors
                            });
                            const supervisorRef = await db.collection('users').doc(selectionSupervisor.supervisorId).get();
                            const allCollaboratorsOfSupervisor = supervisorRef.data()['collaborators'];
                            for(const collaborator of allCollaboratorsOfSupervisor){
                                if(collaborator.email === this.user.email){
                                    collaborator.status = 'accepted';
                                    break;
                                }
                            }
                            await db.collection('users').doc(selectionSupervisor.supervisorId).update({
                                collaborators: allCollaboratorsOfSupervisor
                            });
                            this.listData();
                            swal('Accepted', 'You can now collaborate', 'success');
                        }
                    });
                }catch (e) {
                    console.error(e);
                    swal('Error', 'Error in accepting this collaboration', 'error');
                }

            },
            async deactivateCollaboration(selectionSupervisor, e){
                e.preventDefault();
                console.log(selectionSupervisor);
                swal({
                    title: "Removing collaboration",
                    text: "Are you certain that you want to de-activate this access?",
                    type: "question",
                    confirmButtonText: "Yes Proceed",
                    confirmButtonColor: "#6ACF98",
                    showCancelButton: true,
                    cancelButtonText: "No Thanks",
                    cancelButtonColor: "#EE8057"
                })
                    .then(result => {
                        if (result.value) {
                            // Set asyncDone to false
                            this.supervisors = this.supervisors.filter(item => item.supervisorEmail !== selectionSupervisor.supervisorEmail);
                            db.collection('users').doc(this.user.uid).update({
                                supervisors: this.supervisors
                            }).then(async () => {
                                const supervisorsRef = await db.collection('users').doc(selectionSupervisor.supervisorId).get();
                                let collaborators = supervisorsRef.data()['collaborators'];
                                collaborators = collaborators.filter(item => item.email !== this.user.email);
                                await db.collection('users').doc(selectionSupervisor.supervisorId).update({
                                    collaborators: collaborators
                                });
                                swal('Success!', 'Collaboration has been de-activated successfully!', 'success');
                            })
                        }
                    })
            }
        }
    }
</script>
<style>
    .multiselect__option--highlight{
        background: #5a7cfd !important;
    }
    .multiselect__option--highlight:after{
        background: #5a7cfd !important;
    }
    .multiselect__tag{
        background: #5a7cfd !important;
    }
    .multiselect__tag-icon:hover{
        background: red !important;
    }
    .multiselect__tag-icon:after {
        color: white !important;
    }
</style>
<style scoped>
    .collaboration_container{
        width: 100%;
        display: flex;
    }
    .big_item{
        flex-grow: 2;
        padding-left: 10px;
    }
    .accept_inv{
        padding: 2px;
        color: #EE8057;
        font-size: 17px;
    }
    .reject_inv{
        padding: 2px;
        color: #6ACF98;
        font-size: 17px;
    }
    .nav-tabs .nav-item .nav-link.active:after, .nav-tabs .nav-item .nav-link.active:hover:after, .nav-tabs .nav-item .nav-link.active:focus:after{
        content: none;
    }
    .nav-tabs .nav-item .nav-link.active:before, .nav-tabs .nav-item .nav-link.active:hover:before, .nav-tabs .nav-item .nav-link.active:focus:before{
        content: none;
    }
    .collab_btns{
        border-radius: 0 !important;
        padding: 5px 10px !important;
    }

</style>
